class packageModalCtrl {
  constructor($scope, logger, httpRequest, $uibModalInstance, items1) {
    const selectedFunList = items1.selectedFunList
    $scope.selected = false
    $scope.allFunctionList = []

    $scope.init = function () {
      httpRequest.get_PackOfTenantOrOrg().then((res) => {
        const allFunctionLen = res.data.value.length
        $scope.allFunctionList = res.data.value
        $scope.allChoose(true)

        if (selectedFunList) {
          for (let i = 0; i < allFunctionLen; i++) {
            if (
              selectedFunList.indexOf($scope.allFunctionList[i].packId) > -1
            ) {
              $scope.allFunctionList[i].selected = true
            } else {
              $scope.allFunctionList[i].selected = false
            }
          }
        }
        debugger
        $scope.onSyllableSelect()
      })
    }
    // 关闭
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
    // 确定
    $scope.ok = function ok() {
      const selectedList = $scope.allFunctionList
        .filter((x) => {
          return x.selected == true
        })
        .map((y) => y.packId)
      if (selectedList.length) {
        $uibModalInstance.close({
          selectedList: selectedList,
        })
      } else {
        logger.logError('功能包不能为空，请选择')
      }
    }
    $scope.onSyllableSelect = function onSyllableSelect() {
      $scope.selected = $scope.allFunctionList.every((x) => {
        return x.selected == true
      })
    }
    $scope.allChoose = function allChoose(selected) {
      const len = $scope.allFunctionList.length
      for (let i = 0; i < len; i++) {
        $scope.allFunctionList[i].selected = selected
      }
    }
    $scope.init()
  }
}

packageModalCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  '$uibModalInstance',
  'items1',
]
export default packageModalCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/org/packageModalCtrl.js